/**
 * How many skill badges fit on one row, leaving room for a "+N more" button
 * when they do not all fit.
 *
 * Always at least one skill: a row holding only "+5 more" says nothing about
 * the job. An unmeasured row (width 0, as on the first render) shows them all.
 *
 * @param {number[]} widths   each badge's width, in order
 * @param {number} available  the row's width
 * @param {number} moreWidth  the "+N more" button's width
 * @param {number} gap        the space between items
 * @returns {number}
 */
export const countFittingSkills = (widths, available, moreWidth, gap) => {
  if (!widths.length) return 0;
  if (available <= 0) return widths.length;

  const total = widths.reduce((sum, w) => sum + w, 0) + gap * (widths.length - 1);
  if (total <= available) return widths.length;

  let used = moreWidth;
  let count = 0;
  for (const width of widths) {
    if (used + gap + width > available) break;
    used += gap + width;
    count++;
  }
  return Math.max(count, 1);
};
